import React, {
    useCallback,
    useEffect,
    useState,
    useContext
} from 'react';
import PropTypes from 'prop-types';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { ViewModelForm, ViewModelServiceContext, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { PolicyChange } from 'gw-capability-policychange-common-react';
import { MLAddressVerificationService } from 'gw-capability-quoteandbind';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { useModal } from '@jutro/components';
import { MLTooltipComponent, FormModalPopover } from 'ml-components-platform-react';
import { MLEndorsementFlowUtil, MLEndorsementUtil, MLProductCodeUtil, MLWizardUtil } from 'ml-portals-util-js';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLOutOfSequenceConflictComponent, MLAddressDetailsComponent } from 'ml-components-common-react';
import { MLNavigationStepsTrackingService } from 'ml-services-common-react';
import appConfig from 'app-config';
import { withRouter } from 'react-router-dom';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
import mlAddressChangeTypePopupMsg from '../../components/MLAddressChangeTypePopup/MLAddressChangeTypePopup.messages';

import { Identify  } from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent';
import MLAddressChangeTypePopup from '../../components/MLAddressChangeTypePopup/MLAddressChangeTypePopup';
import mLAddressChangeNewStatePopupMsg from '../../components/MLAddressChangeNewStatePopup/MLAddressChangeNewStatePopup.messages';
import MLAddressChangeNewStatePopup from '../../components/MLAddressChangeNewStatePopup/MLAddressChangeNewStatePopup';
import metadata from './AddressPagePolChange.metadata.json5';

import messages from './AddressPagePolChange.messages';
import styles from './AddressPagePolChange.module.scss';
import { ScrollToError } from '@jutro/legacy/wizard-next';

function StartNewQuoteTooltipComponent(props) {
    StartNewQuoteTooltipComponent.propTypes = {
        tooltipHeader: PropTypes.shape({}),
        tooltipLabel: PropTypes.shape({}),
        tooltipContent: PropTypes.shape({}).isRequired
    };
    const { tooltipHeader, tooltipLabel, tooltipContent, className } = props;
    return (
        <div className={className}>
            <MLTooltipComponent
                tooltipHeader={tooltipHeader}
                tooltipLabel={tooltipLabel}
                tooltipContent={tooltipContent}
                noWrapper
            />
        </div>
    );
}

const AddressPagePolChange = (props) => {
    const modalApi = useModal();
    const {
        wizardData,
        updateWizardData,
        goNext,
        currentStepIndex,
        steps,
        currentStep,
        changeNextSteps,
        history
    } = props;
    const { submissionVM } = wizardData;
    const { EndorsementService } = useDependencies('EndorsementService');
    const { PolicyService } = useDependencies('PolicyService');
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();

    const {
        showProgressDialog
    } = MLModalService();

    const {
        clearAlerts,
        addWarningAlert,
        addSuccessAlert,
        clearBlockAlerts,
        addErrorAlert
    } = MLNotificationBlockUtil();

    const alertId = 'addressChangeAlert';
    const agentAlerts = {
        addressAlertMsg: translator(messages.youHaveChangedYourAddress),
        addressAlertMsgForPA: translator(messages.verifyYourGaragingAddress)
    };
    const nonAgentAlerts = {
        addressAlertMsg: translator(messages.addressHasBeenChaged),
        addressAlertMsgForPA: translator(messages.verifyTheGaragingAddress),
    };

    const isAgent = appConfig.portalCode === 'GPA';
    const isAmp = appConfig.portalCode === 'AMP';
    const MLQBPath = "http://www.myautohome.farmers.com/";
    const isOOSConflict = _.get(submissionVM, 'isOutOfSequenceConflict_ML.value');
    const isPersonalAuto = submissionVM.value.isPersonalAuto();
    const isPersonalUmbrella = submissionVM.value.isPersonalUmbrella();
    const isRenters = submissionVM.value.isRenters();
    const isHomeOwners = submissionVM.value.isHomeOwners();
    const isLandlordHome = MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(submissionVM.baseData.productCode.value);
    const isLandlordCondo = MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(submissionVM.baseData.productCode.value);

    const policyAddress = submissionVM.baseData.policyAddress;
    const physicalLocationAddress_ML = submissionVM.baseData.physicalLocationAddress_ML;
    const mailingAddress = submissionVM.baseData.mailingAddress_ML;
    const sameMailingAddress = submissionVM.baseData.sameMailingAddress_ML;

    const [previousPolicyAddress, setPreviousPolicyAddress] = useState({});
    const [previousPhysicalAddress, setPreviousPhysicalAddress] = useState({});
    const [policyAddressChangeFlag, setPolicyAddressChangeFlag] = useState(false);
    const [disableContinueFlag, setDisableContinueFlag] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isPolicyAddressEditable, setIsPolicyAddressEditable] = useState(isPersonalAuto || isPersonalUmbrella);
    const [accountLocations, setAccountLocations] = useState([]);
    const [showErrors, updateShowErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const changeMailingAddressValue = _.get(submissionVM, 'baseData.changeMailingAddQuestion_Ext.value');
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);

    const isLLHOrLLC = MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(submissionVM.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code)
                || MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(submissionVM.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code);

    const deedInfo_Ext = _.get(submissionVM, 'baseData.deedInfo_Ext.value');
    const [dwellingDeedInfo, setDwellingDeedInfo] = useState(_.get(submissionVM, 'baseData.dwellingDeedInfo_Ext.value'));
    const [isOwnerChangedVisible, setIsOwnerChangedVisible] = useState(false);
    const [deedInitialValue, setDeedInitialValue] = useState(_.get(submissionVM, 'baseData.deedInfo_Ext.value'));
    const { refreshData } = useDataRefresh();
    const { onValidate } = useValidation('AddressPagePolChange');

    const addAlertOfType = (alertMessage) => {
        if (isPersonalAuto) {
            addWarningAlert(alertMessage, alertId);
        } else {
            addSuccessAlert(alertMessage, alertId);
        }
    };

    const showAlerts = (addressChangeFlag) => {
        clearAlerts();
        if (addressChangeFlag) {
            let alertMessage;
            if (!isAgent) {
                alertMessage = isPersonalAuto ? `${agentAlerts.addressAlertMsg}${agentAlerts.addressAlertMsgForPA}` : agentAlerts.addressAlertMsg;
            } else {
                alertMessage = isPersonalAuto ? `${nonAgentAlerts.addressAlertMsg}${nonAgentAlerts.addressAlertMsgForPA}` : nonAgentAlerts.addressAlertMsg;
            }
            addAlertOfType(alertMessage);
        }
    };

    const updateWizardSubmissionData = useCallback((vm) => {
        _.set(wizardData, 'submissionVM', vm);
        updateWizardData(wizardData);
    }, [updateWizardData, wizardData]);

    useEffect(() => {
        Identify('Endorsement Step Reached', {step: 'Address Screen'}, submissionVM, authHeader)
    }, [])
    
    useEffect(() => {
        MLNavigationStepsTrackingService.addToDynamicSteps(translator(messages.updatedAddresses), false, currentStep.mlStepName, authHeader);
        if (isPersonalAuto) {
            setPreviousPhysicalAddress(_.cloneDeep(submissionVM.baseData.physicalLocationAddress_ML.value));
        }
        setPreviousPolicyAddress(_.cloneDeep(submissionVM.baseData.policyAddress.value));
        const initSameMailingAddress = _.isUndefined(submissionVM.baseData.value.sameMailingAddress_ML) ? true : submissionVM.baseData.sameMailingAddress_ML.value;
        _.set(submissionVM, 'baseData.sameMailingAddress_ML.value', initSameMailingAddress);
        updateWizardSubmissionData(submissionVM);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const setInitialValuesForDeed = () => {
            setDeedInitialValue(_.get(submissionVM, 'baseData.deedInfo_Ext.value'));
            setDwellingDeedInfo(_.get(submissionVM, 'baseData.dwellingDeedInfo_Ext.value'));
        }
        if (isAgent) {
            PolChangeTrackEvent('Endorsement Step Reached', false, submissionVM, authHeader, { step: 'PolChange Address Screen' });
        }
        setInitialValuesForDeed();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        showAlerts(false);
        setLoading(true);
        PolicyService.getAvailableMailingLocations(submissionVM.baseData.accountNumber.value, submissionVM.policyNumber.value, authHeader)
            .then((locations) => {
                locations.accountLocations.forEach((loc) => {
                    loc.addressType = 'mailing_ml';
                });
                setAccountLocations(locations.accountLocations);
            })
            .finally(() => {
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getNextStepText = () => {
        return (
            <FormattedMessage
                {...messages.nextBaseDescription}
                values={{
                    bold: (
                        <strong>{translator(messages.nextDescriptionBold)}</strong>
                    )
                }}
            />
        );
    };

    const handlePolicyAddressChangeFlag = (b) => {
        setPolicyAddressChangeFlag(b);
        showAlerts(b);
    };

    const syncAddresses = (fromAddressVal, toAddressVal, addressPath) => {
        const newAddressVal = {
            ...toAddressVal,
            addressLine1: fromAddressVal.addressLine1,
            addressLine2: fromAddressVal.addressLine2,
            city: fromAddressVal.city,
            state: fromAddressVal.state,
            postalCode: fromAddressVal.postalCode,
            displayName: fromAddressVal.displayName,
            addressType: fromAddressVal.addressType
        };
        _.set(submissionVM, addressPath, newAddressVal);
        updateWizardSubmissionData(submissionVM);
    };

    const clearMailingAddress = (addressVal) => {
        const newAddressVal = {
            ...addressVal,
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            postalCode: '',
            displayName: ''
        };
        _.set(submissionVM, 'baseData.mailingAddress_ML.value', newAddressVal);
        updateWizardSubmissionData(submissionVM);
    };

    const startNewQuote = useCallback(() => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Start a new quote`);
        history.push(`/new-quote/${submissionVM.baseData.accountNumber.value}`)
    }, [history, submissionVM.baseData.accountNumber.value]);

    const openEditAddressModal = () => {
        if (isRenters || isPersonalAuto || isPersonalUmbrella) {
            setIsPolicyAddressEditable(true);
            return;
        }
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Edit Address`);
        const componentProps = {
            title: translator(mlAddressChangeTypePopupMsg.whatTypeOfAddressChange),
            overrideProps: {
                isAgent,
                MLQBPath,
                startNewQuote,
                setIsPolicyAddressEditable
            },
            CustomComponent: MLAddressChangeTypePopup,
            showFooterOnCustomComponent: false,
            additionalPEStyle: 'customFooterModal',
            cancelBtnLabel: mlAddressChangeTypePopupMsg.cancel
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const onChangePolicyAddress = (newAddress) => {
        if (sameMailingAddress.value) {
            syncAddresses(newAddress.value, mailingAddress.value, 'baseData.mailingAddress_ML.value');
        }
        if (isHomeOwners) {
            const dwellingAddressVal = submissionVM.lobData.homeowners.coverables.policyAddress.value;
            syncAddresses(newAddress.value, dwellingAddressVal, 'lobData.homeowners.coverables.policyAddress.value');
            _.set(submissionVM, 'lobData.homeowners.coverables.policyAddress.value', newAddress.value);
        }
        if (isPersonalAuto) {
            _.set(submissionVM, 'baseData.physicalLocationAddress_ML.value', newAddress.value);
        }
        _.set(submissionVM, 'baseData.policyAddress.value', newAddress.value);
        updateWizardSubmissionData(submissionVM);
        refreshData();
    };

    const onBlurPolicyAddress = () => {
        if (_.isEqual(policyAddress.value, previousPolicyAddress)) {
            handlePolicyAddressChangeFlag(false);
        } else {
            handlePolicyAddressChangeFlag(true);
        }

        // state change
        if (policyAddress.value.state !== previousPolicyAddress.state) {
            const componentProps = {
                title: translator(mLAddressChangeNewStatePopupMsg.zipcodeEnteredForDiffState),
                overrideProps: {
                    isAmp,
                    MLQBPath,
                    startNewQuote,
                    restorePolicyAddress: () => {
                        if (isPersonalAuto) {
                            syncAddresses(previousPhysicalAddress, physicalLocationAddress_ML.value, 'baseData.physicalLocationAddress_ML.value');
                        }

                        syncAddresses(previousPolicyAddress, policyAddress.value, 'baseData.policyAddress.value');
                    }
                },
                CustomComponent: MLAddressChangeNewStatePopup,
                showFooterOnCustomComponent: false,
                additionalPEStyle: 'customFooterModal'
            };

            modalApi.showModal(
                <FormModalPopover {...componentProps} />
            );
        }
    };

    const onChangeMailingAddress = () => {
        refreshData();
    };

    const onBlurMailingAddress = () => {
        setDisableContinueFlag(true);
    };

    const onChangeSameMailingAddress = (newValue) => {
        setDisableContinueFlag(false);
        if (newValue) {
            syncAddresses(policyAddress.value, mailingAddress.value, 'baseData.mailingAddress_ML.value');
        } else {
            clearMailingAddress(mailingAddress.value);
        }
        _.set(submissionVM, 'baseData.sameMailingAddress_ML.value', newValue);
        updateWizardSubmissionData(submissionVM);
    };

    const populateMailingAddress = (location) => {
        setDisableContinueFlag(true);
        syncAddresses(location, mailingAddress.value, 'baseData.mailingAddress_ML.value');
    };

    const getMailingAddressQuestion = useCallback(() => {
        let questionText;
        if (isAgent) {
            questionText = translator(messages.isMailingAddressSameAsAboveAddress);
        } else {
            questionText = isHomeOwners ? translator(messages.isMailingAddressSameAsInsuredResidence) : translator(messages.isMailingAddressSameAsYourAddress);
        }
        return questionText;
    }, [isAgent, isHomeOwners, translator]);

    const updateOtherAddresses = () => {
        if (sameMailingAddress.value) {
            syncAddresses(policyAddress.value, mailingAddress.value, 'baseData.mailingAddress_ML.value');
        }
    };

    const updateMailingAddressFields = (address) => {
        const newAddressVal = {
            ...mailingAddress.value,
            addressLine1: address.addressLine1,
            addressLine2: address.addressLine2,
            city: address.city,
            state: address.state,
            postalCode: address.postalCode
        };
        _.set(submissionVM, 'baseData.mailingAddress_ML.value', newAddressVal);
        updateWizardSubmissionData(submissionVM);
    };

    const saveMailingAddress = () => {
        if (!(submissionVM.aspects.valid && submissionVM.aspects.subtreeValid)) {
            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp + 1);
            return;
        }
        const updatePromise = EndorsementService.saveEndorsement([submissionVM.value], authHeader);
        showProgressDialog(messages.saving, updatePromise);
        updatePromise.then((pc) => {
            updateMailingAddressFields(pc.baseData.mailingAddress_ML);
        }).finally(() => {
            setDisableContinueFlag(false);
        });
    };

    const getFormattedCityStatePostalCode = (city, state, postalCode) => {
        const wrappedCity = _.isEmpty(city) ? '' : city;
        const wrappedState = _.isEmpty(state) ? '' : state;
        const wrappedPostalCode = _.isEmpty(postalCode) ? '' : postalCode;
        return wrappedCity === '' ? `${wrappedState} ${wrappedPostalCode}` : `${wrappedCity}, ${wrappedState} ${wrappedPostalCode}`
    };

    const isContinueButtonDisabled = () => {
        return (disableContinueFlag && isAmp) || isOOSConflict;
    };

    const jumpToSelectedStepByStepID = (newStepID) => {
        MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, steps, currentStepIndex, changeNextSteps, goNext, submissionVM.baseData.productCode.value)
    };

    const saveAndProceed = () => {
        const lbl = MLEndorsementUtil.stepLabel(currentStep);
        MLEndorsementUtil.setEndorsementDescription(lbl, submissionVM, translator);
        const promise = EndorsementService.saveEndorsement([submissionVM.value], authHeader);
        showProgressDialog(messages.loading, promise);
        promise.then((updatedPolicyChange) => {
            MLNavigationStepsTrackingService.setJobNumber(updatedPolicyChange.jobID);
            const policyChange = new PolicyChange(Object.assign({}, updatedPolicyChange));
            const updatedEndorsementVM = viewModelService.create(policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');
            MLNavigationStepsTrackingService.completeCurrentStep(null, authHeader);
            updateWizardSubmissionData(updatedEndorsementVM);
            jumpToSelectedStepByStepID('endorsementAdditionalChanges');
        });
    };

    const deedValuesAreInvald = () => {
        let isInvalid = false;
        const deedValue = _.get(submissionVM, 'baseData.deedInfo_Ext.value');
        const dwellingInforValue = _.get(submissionVM, 'baseData.dwellingDeedInfo_Ext.value');
        const hasOwnerShipChangedValue = _.get(submissionVM, 'baseData.hasOwnershipChanged.value');
        if((deedValue === true || deedValue === 'true') && (_.isUndefined(dwellingInforValue) || _.isNull(dwellingInforValue) || dwellingInforValue.trim() === '')) {
            isInvalid = true;
        }
        else if(isOwnerChangedVisible && _.isUndefined(hasOwnerShipChangedValue)) {
            isInvalid = true;
        }
        return isInvalid;
    }

    const ownerShipChanged = () => {
        return _.get(submissionVM, 'baseData.hasOwnershipChanged.value');
    }

    const updateEntityNameIfDeedUpdated = useCallback(() => {
        const deedValue = _.get(submissionVM, 'baseData.deedInfo_Ext.value');
        const hasOwnerShipChangedValue = _.get(submissionVM, 'baseData.hasOwnershipChanged.value');
        if (deedValue === false) {
            _.set(submissionVM, 'baseData.dwellingDeedInfo_Ext.value', undefined);
        }
        if(!isOwnerChangedVisible && !_.isUndefined(hasOwnerShipChangedValue)) {
            _.set(submissionVM, 'baseData.hasOwnershipChanged.value', undefined);
        }
        updateWizardSubmissionData(submissionVM);
        refreshData();
    },[updateWizardSubmissionData, submissionVM]);

    const onNext = () => {

        if (isModernProduct && isLLHOrLLC) {
            updateEntityNameIfDeedUpdated();
        }

        submissionVM.isSubmitAgent = isAgent;
        clearBlockAlerts('OwnershipChanged');
        clearBlockAlerts('missingDeeedInfo');

        if (isModernProduct && isLLHOrLLC && ownerShipChanged()) {
            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp + 1);
            addErrorAlert(messages.ownerShipChangedError, 'OwnershipChanged');
            return;
        }
        if (!(submissionVM.aspects.valid && submissionVM.aspects.subtreeValid)) {
            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp + 1);
            return;
        }
        if (policyAddressChangeFlag) {
            MLAddressVerificationService.validateAddress(viewModelService, submissionVM.baseData.policyAddress, submissionVM.baseData.productCode.value)
                .then(() => {
                    updateOtherAddresses();
                    saveAndProceed();
                })
        }

        if(isModernProduct && isLLHOrLLC && deedValuesAreInvald()) {
            updateShowErrors(true);
            addErrorAlert(messages.updateRequiredFields, 'missingDeeedInfo');
            setErrorTimestamp(errorTimestamp + 1);
            return;
        }
        else {
            saveAndProceed();
        }

        if (isAgent) {
            PolChangeTrackEvent('Endorsement Step Submitted', false, submissionVM, authHeader, {
                step: 'PolChange Address Screen',
                action: 'Address Submitted'
            });
        }
    };

    const resolvers = {
        resolveComponentMap: {
            mloutofsequenceconflictcomponent: MLOutOfSequenceConflictComponent,
            mlAddressDetailsComponent: MLAddressDetailsComponent,
            startNewQuoteTooltipComponent: StartNewQuoteTooltipComponent
        },
        resolveCallbackMap: {
            onValidate: onValidate,
            onNext: onNext,
            openEditAddressModal,
            startNewQuote,
            saveMailingAddress
        },
        resolveClassNameMap: styles
    };

    const isEmptyMailingAddress = mailingAddress?.value
        && typeof mailingAddress.value === 'object'
        && Object.keys(mailingAddress.value).length === 0;
   
    const hasValidMailingAddress = (address) => {
        if (!address || Object.keys(address).length === 0) {
            return false;
        }
        if (
            Object.keys(address).length === 1 &&
            address.country === 'US'
        ) {
            return false;
        }
        return true;
    };

    const isBlankAddress = (address) => {
        if (!address) {
            return true;
        }

        return ![
            address.addressLine1,
            address.city,
            address.state,
            address.postalCode
        ].some(value => value?.trim());
    };
       
    const isAddressMatch = isEmptyMailingAddress || isBlankAddress(mailingAddress?.value) || !hasValidMailingAddress(mailingAddress?.value)    //indicates the mailing and primary address are not yet different and visibility will be hidden
                        ? true : MLWizardUtil.areAddressesEqual(mailingAddress?.value, policyAddress?.value);                    
   
    const isSupportedProduct = !submissionVM.value.isLandlordCondo() && !submissionVM.value.isLandlordHome();
   
    const isFutureEffectiveDate = submissionVM?.value?.baseData?.periodStartDate?.year &&
            new Date(
                submissionVM?.value?.baseData?.periodStartDate?.year,
                submissionVM?.value?.baseData?.periodStartDate?.month,
                submissionVM?.value?.baseData?.periodStartDate?.day
            ) > new Date();
 
    const isChangeMailingAddressQuestionVisible = () => {
        return isFutureEffectiveDate && isSupportedProduct && !isAddressMatch;
    };
    // Default changeMailingAddQuestion_Ext to false when the question becomes visible
    useEffect(() => {
        if (isChangeMailingAddressQuestionVisible() && _.isUndefined(changeMailingAddressValue)) {
            _.set(submissionVM, 'baseData.changeMailingAddQuestion_Ext.value', false);
            updateWizardSubmissionData(submissionVM);
        }
    }, [isFutureEffectiveDate, isSupportedProduct, isAddressMatch]);

     const updateChangeMailingAddress = useCallback((newValue) => {
        _.set(submissionVM, 'baseData.changeMailingAddQuestion_Ext.value', newValue);
        updateWizardSubmissionData(submissionVM);
    }, [submissionVM, updateWizardSubmissionData]);

    const generateOverrides = () => {
        const overrides = accountLocations.map((item, index) => {
            return {
                [`accountAddressLine2${index}`]: {
                    visible: policyAddress.addressLine2
                },
                [`accountAddressLine3${index}`]: {
                    visible: policyAddress.addressLine3
                },
                [`accountCityStateZipcode${index}`]: {
                    content: getFormattedCityStatePostalCode(item.city, item.state, item.postalCode)
                },
                [`accountAddressLink${index}`]: {
                    onClick: () => populateMailingAddress(item)
                }
            };
        });
        return Object.assign({}, ...overrides);
    };

    const onDwellingDeedBusinessChange = useCallback((newValue) => {
        const clonedVM = viewModelService.clone(submissionVM);
        _.set(clonedVM, 'baseData.deedInfo_Ext.value', newValue);
        _.set(clonedVM, 'value.baseData.deedInfo_Ext', newValue);
        if (deedInitialValue != newValue) {
            setIsOwnerChangedVisible(true);
        }
        else {
            setIsOwnerChangedVisible(false);
        }
        updateWizardSubmissionData(clonedVM);

    }, [submissionVM, updateWizardSubmissionData, viewModelService]);

    const onDwellingDeedInfoChange = useCallback((newValue) => {
        const clonedVM = viewModelService.clone(submissionVM);
        _.set(clonedVM, 'baseData.dwellingDeedInfo_Ext.value', newValue);
        if (dwellingDeedInfo != newValue) {
            setIsOwnerChangedVisible(true);
        }
        else {
            setIsOwnerChangedVisible(false);
        }
        updateWizardSubmissionData(clonedVM);
    }, [submissionVM, updateWizardSubmissionData, viewModelService]);

    const overrides = {
        oosComponent: {
            isOOSConflict,
            isAgent
        },
        mlAddressChangeDetailsContainer: {
            className: isAgent ? 'page-content-gpa' : '',
        },
        addressHeader: {
            visible: isAgent
        },
        insuredResidence: {
            visible: isHomeOwners
        },
        addressOfProperty: {
            visible: isHomeOwners
        },
        insuredAddress: {
            visible: !isHomeOwners && isAgent
        },
        yourAddress: {
            visible: !isHomeOwners && !isAgent
        },
        policyAddressReadonly: {
            visible: !isPolicyAddressEditable
        },
        addressLine1Readonly: {
            content: policyAddress.addressLine1.value
        },
        addressLine2Readonly: {
            visible: !_.isEmpty(policyAddress.addressLine2.value),
            content: policyAddress.addressLine2.value
        },
        addressLine3Readonly: {
            visible: !_.isEmpty(policyAddress.addressLine3.value),
            content: policyAddress.addressLine3.value
        },
        cityStateZipcodeReadonly: {
            content: getFormattedCityStatePostalCode(_.get(policyAddress, 'city.value'), _.get(policyAddress, 'state.value.code'), _.get(policyAddress, 'postalCode.value'))
        },
        policyAddressEditable: {
            visible: isPolicyAddressEditable
        },
        policyAddressComponent: {
            addressVM: policyAddress,
            onModelChange: onChangePolicyAddress,
            onModelBlur: onBlurPolicyAddress,
            cityStateLookUp: true,
            layout: 'ml-policy-change',
            onValidate,
            showValidationErrors: showErrors
        },
        changeAddressAgent: {
            visible: isAgent
        },
        changeAddressNonAgent: {
            visible: !isAgent
        },
        startNewCustomerQuote: {
            visible: isAgent
        },
        contactAgent: {
            visible: !isAgent
        },
        startNewQuoteBtn: {
            visible: isAgent
        },
        startNewQuoteLink: {
            visible: !isAgent,
            href: MLQBPath,
            mlTagManagerLinkClick: "Address details_Start a new quote"
        },
        startNewQuoteTooltip: {
            visible: !isAgent,
            tooltipHeader: messages.whenToStartANewQuote,
            tooltipLabel: messages.whenToStartANewQuote,
            tooltipContent: messages.leavePolicy,
            className: "tooltip hidden-xs"
        },
        mailingAddressRadioBtn: {
            value: sameMailingAddress.value,
            onValueChange: onChangeSameMailingAddress,
            label: getMailingAddressQuestion()
        },
        addressPopoverContainer: {
            visible: !sameMailingAddress.value
        },
        accountLocationsContainer: {
            visible: !loading && accountLocations.length > 0
        },
        accountLocationsIterable: {
            data: accountLocations
        },
        addTheAddress: {
            visible: isAgent
        },
        addYourAddress: {
            visible: !isAgent
        },
        mailingAddressComponent: {
            addressVM: mailingAddress,
            onModelChange: onChangeMailingAddress,
            onModelBlur: onBlurMailingAddress,
            cityStateLookUp: true,
            layout: 'ml-policy-change',
            onValidate,
            showValidationErrors: showErrors
        },
        useMailingAddressBtn: {
            visible: disableContinueFlag
        },
        nextDescription: {
            content: getNextStepText()
        },
        nextButton: {
            disabled: isContinueButtonDisabled()
        },
        stickyContinueSection: {
            visible: isAgent,
            defaultContinueSectionId: 'footer',
            nextDescription: getNextStepText(),
            disableNext: isContinueButtonDisabled(),
            onNext
        },
        changeMailingAddressContainer :{
            visible: isChangeMailingAddressQuestionVisible()
        },
        changeMailingAddressRadioButton: {
            value: changeMailingAddressValue,
            onValueChange: updateChangeMailingAddress
        },
        dwellingDeedBusinessContainer: {
            visible: isModernProduct && isLLHOrLLC,
        },
        dwellingDeedBusinessRadioButton: {
            visible: isModernProduct && isLLHOrLLC,
            value: deedInfo_Ext,
            required: isModernProduct && isLLHOrLLC,
            onValueChange: onDwellingDeedBusinessChange,
        },
        deedOrTitle: {
            visible: isModernProduct && isLLHOrLLC && (deedInfo_Ext === true || deedInfo_Ext === 'true'),
            required: isModernProduct && isLLHOrLLC && (deedInfo_Ext === true || deedInfo_Ext === 'true'),
            onValueChange: onDwellingDeedInfoChange,
            value: _.get(submissionVM, 'baseData.dwellingDeedInfo_Ext.value'),
        },
        ownerShipChangedRadioButton: {
            visible : isModernProduct && isLLHOrLLC && isOwnerChangedVisible,
            required: isModernProduct && isLLHOrLLC && isOwnerChangedVisible,
            value: _.get(submissionVM, 'baseData.hasOwnershipChanged.value'),
            onValueChange: (value, path) => {
                _.set(submissionVM, path, value);
                refreshData();
            },
        },
        hrDivider2: {
            visible: isModernProduct && isLLHOrLLC,
        },

        ...generateOverrides()
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            showNext={false}
            policyChangePageHeaderML={isAgent ? messages.makeChanges : messages.addressDetail}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                model={wizardData}
                onModelChange={updateWizardData}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                onValidationChange={onValidate}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
};

AddressPagePolChange.propTypes = wizardProps;
export default withAuthenticationContext(withRouter(AddressPagePolChange));
